module.exports = __webpack_public_path__ + "img/dashboard.fe52baaa.png";